import { ApolloClient, ApolloLink, fromPromise, HttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';

import { getToken } from '../utils/localStorage';
import { api } from '../services';

const rawBaseUrl = process.env.REACT_APP_BASE_URL || '';
const baseUrl = rawBaseUrl.trim();

if (!baseUrl) {
  console.error('[GraphQL] REACT_APP_BASE_URL fehlt oder ist leer.');
} else if (rawBaseUrl !== baseUrl) {
  console.warn('[GraphQL] REACT_APP_BASE_URL hat Leerzeichen. Verwende getrimmte URL.', {
    rawBaseUrl,
    baseUrl
  });
} else {
  console.info('[GraphQL] REACT_APP_BASE_URL', { baseUrl });
}

const httpLink = new HttpLink({
  uri: baseUrl
});

const authMiddleware = setContext(async (_, { headers }) => {
  let token = getToken();

  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : ''
    }
  };
});

let isRefreshing = false;
let pendingRequests = [];

const resolvePendingRequests = () => {
  pendingRequests.map((callback) => callback());
  pendingRequests = [];
};

const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
  let forward$;

  if (graphQLErrors) {
    graphQLErrors.forEach((error) => {
      console.error('[GraphQL] Fehler', {
        operation: operation?.operationName,
        message: error.message,
        code: error.extensions?.code
      });
      if (error.extensions.code === 'INTERNAL_SERVER_ERROR') {
        if (!isRefreshing) {
          isRefreshing = true;
          forward$ = fromPromise(
            api.authenticate
              .refreshToken()
              .then((token) => {
                const oldHeaders = operation.getContext().headers;

                operation.setContext({
                  headers: {
                    ...oldHeaders,
                    Authorization: token ? `Bearer ${token}` : ''
                  }
                });

                resolvePendingRequests();
                return token;
              })
              .catch(() => {
                pendingRequests = [];
              })
              .finally(() => {
                isRefreshing = false;
              })
          );
        } else {
          // Will only emit once the Promise is resolved
          forward$ = fromPromise(
            new Promise((resolve) => {
              pendingRequests.push(() => resolve());
            })
          );
        }
      }
    });
  }
  if (forward$) {
    return forward$.filter(Boolean).flatMap(() => forward(operation));
  }

  if (networkError) {
    console.error('[GraphQL] Network error', {
      operation: operation?.operationName,
      message: networkError.message,
      statusCode: networkError.statusCode,
      bodyText: networkError.bodyText
    });
  }
});

const logLink = new ApolloLink((operation, forward) => {
  console.info('[GraphQL] Request', {
    operation: operation.operationName,
    variables: operation.variables,
    uri: baseUrl
  });
  if (!forward) {
    return null;
  }
  return forward(operation).map((result) => {
    console.info('[GraphQL] Response', {
      operation: operation.operationName,
      hasErrors: Boolean(result?.errors?.length)
    });
    return result;
  });
});

const client = new ApolloClient({
  cache: new InMemoryCache({
    typePolicies: {
      Connector: {
        keyFields: ['evseId']
      }
    }
  }),
  link: ApolloLink.from([authMiddleware, logLink, errorLink, httpLink])
});

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
  },
  query: {
    fetchPolicy: 'no-cache',
  },
  mutation:{
    fetchPolicy: 'no-cache',
  }
}
const clientForUserTable = new ApolloClient({
  cache: new InMemoryCache(),
  defaultOptions: defaultOptions,
  link: ApolloLink.from([authMiddleware, logLink, errorLink, httpLink])
});

export default client;
export {clientForUserTable}
